import React from 'react';
import styled from 'styled-components';
import { BigText, Button } from '../common';

const Wrapper = styled.div`
    padding: 0 0 50px 0;
`;

const FileWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    column-gap: 10px;
    row-gap: 10px;
    @media (max-width: 980px) {
        flex-direction: column;
    }
`;

const A = styled.a`
    text-decoration: none;
`;

const Heading = styled(BigText)``;

const StyledButton = styled(Button)`
    padding: 10px;
`;

export const AdditionalInfoFiles = ({ files }) => {
    const renderFiles = () =>
        files.map((file, index) => (
            <div key={index}>
                <A
                    href={file.file.publicURL}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <StyledButton>{file.anzeigename}</StyledButton>
                </A>
            </div>
        ));

    return (
        <Wrapper>
            <Heading>Dateien</Heading>
            <FileWrapper>{renderFiles()}</FileWrapper>
        </Wrapper>
    );
};
